import { createSvgIcon } from '../../createSvgIcon';

const strokeProps = {
  stroke: 'currentColor',
  strokeWidth: 1.5,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const
};

export const DeskIcon = createSvgIcon(
  <>
    <path d="M23.3867 12.0681L15.0006 12.0681M18.9607 16.0282L15.0006 12.0681L18.9607 8.10801" {...strokeProps} />
    <path d="M0.749996 12.0681L9.13611 12.0681M5.176 16.0282L9.13611 12.0681L5.176 8.10801" {...strokeProps} />
    <path d="M12.0682 23.3864V15.0003M8.10809 18.9604L12.0682 15.0003L16.0283 18.9604" {...strokeProps} />
    <path d="M12.0682 0.749997L12.0682 9.13611M8.10809 5.176L12.0682 9.13611L16.0283 5.176" {...strokeProps} />
  </>,
  { displayName: 'DeskIcon', viewBox: '0 0 25 25' }
);
